module.exports = "/assets/5aef3f6738b1bdaa67eb0bbdc6102b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TG.png
// module id = 1855
// module chunks = 0